import React from 'react';
import Icon from '../Icons';
import { useGlobal } from '../../contexts/Global/context';
import * as S from './styles';

function StepProgress({ steps = [], activeStep }) {
    const { contrastTheme } = useGlobal();

    return (
        <>
            <div className="hide-mobile-1200">
                <S.Container>
                    {steps.map((step, index) => {
                        const numStep = index + 1;
                        const isLastStep = numStep === steps.length;

                        let stepStatus = 'finished';

                        if (numStep === activeStep) {
                            stepStatus = 'active';
                        } else if (numStep > activeStep) {
                            stepStatus = 'pending';
                        }

                        return (
                            <React.Fragment key={`step-${index}`}>
                                <S.Step data-status={stepStatus}>
                                    <S.Circle>
                                        {stepStatus === 'finished' ? (
                                            <Icon
                                                name="check"
                                                type="round"
                                                size={30}
                                                style={{ color: contrastTheme ? '#000000' : '#FFFFFF' }}
                                            />
                                        ) : (
                                            numStep
                                        )}
                                    </S.Circle>
                                    <S.Label>{step}</S.Label>
                                </S.Step>
                                {!isLastStep && <S.Divider data-status={stepStatus} />}
                            </React.Fragment>
                        );
                    })}
                </S.Container>
            </div>

            <div className="hide-desktop-1200">
                <S.ContainerMobile>
                    <S.StepMobile>
                        <S.Circle className="mobile">{activeStep}</S.Circle>
                        <S.StepDescription>
                            <span>{`Passo ${activeStep} de ${steps.length}`}</span>
                            <label htmlFor="first-Step">{steps[activeStep - 1]}</label>
                        </S.StepDescription>
                    </S.StepMobile>

                    <S.ProgressBar value={(activeStep / steps.length) * 100} max="100" />
                </S.ContainerMobile>
            </div>
        </>
    );
}

export default StepProgress;
